import { CompanyGroup } from "@/interfaces/companyGroup";
import { CustomAxiosRequestConfig } from "@/interfaces/customAxiosRequestConfig";
import { PaginatedResponse } from "@/interfaces/paginatedResponse";
import axios from "@/lib/axios";
import useCompanies from "@/modules/companies/composables/useCompanies";
import { useCompanyGroupsStore } from "@/stores/companyGroupsSearch";
import { useQuery } from "@tanstack/vue-query";
import _ from "lodash";
import { storeToRefs } from "pinia";
import { watch } from "vue";

interface Props {
  immediate?: boolean;
  params?: Params;
  errorHandling?: boolean;
}

type Params = {
  companyId?: number;
  page?: string;
  errorHandling?: boolean;
};

const getCompanyGroups = async ({
  companyId,
  page = "1",
  errorHandling = false,
}: Params): Promise<CompanyGroup[]> => {
  const { data } = await axios.get<CompanyGroup[]>(
    `/api/companies/${companyId}/groups?page=${page}`,
    { errorHandling: errorHandling } as CustomAxiosRequestConfig,
  );

  return data;
};

export const useCompanyGroups = ({ immediate, params }: Props) => {
  const { setCompany, setPage, setPagination } = useCompanyGroupsStore();
  const {
    company: companyId,
    page,
    pagination,
  } = storeToRefs(useCompanyGroupsStore());

  const { data, isLoading, isError, isFetched, refetch, isFetching } = useQuery(
    {
      queryKey: ["companyGroups", params?.companyId],
      queryFn: () =>
        getCompanyGroups({
          companyId: companyId.value || params?.companyId!,
          page: page.value,
          errorHandling: params?.errorHandling,
        }),
      retry: false,
      enabled: immediate,
    },
  );

  const searchByCompany = () => {
    refetch();
  };

  watch(companyId, (value) => {
    if (value) {
      searchByCompany();
    }
  });

  watch(data, (value) => {
    // Ya no necesitamos setPagination porque los datos son directos
    // if (value) {
    //   setPagination(_.omit(value, ["data"]));
    // }
  });

  return {
    data,
    isLoading,
    isError,
    isFetched,
    isFetching,
    pagination,
    page,
    companyId,

    setCompany,
    refetch,
    setPage,
    searchByCompany,
  };
};
